var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dropdown"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.58983 4.8042L13.4101 4.8042C14.0573 4.8042 14.4607 5.51794 14.1345 6.08627L9.72433 13.7725C9.40071 14.3365 8.59918 14.3365 8.27563 13.7725L3.86548 6.08627C3.53938 5.51794 3.94258 4.8042 4.58983 4.8042Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.e1f4a0a266fa5aef56a3c9a887563862.svg";
export { ForwardRef as ReactComponent };